import { Controller } from "stimulus"
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ['table']

  // connect() {
  //   this.resizableGrid(this.tableTarget)
  //   for (var i=0;i<cols.length;i++){
  //     var div = createDiv(table.offsetHeight);
  //     cols[i].appendChild(div);
  //     cols[i].style.position = 'relative';
  //     setListeners(div);
  //    }
  // }

  resizableGrid(table) {
    var row = table.getElementsByTagName('tr')[0],
    cols = row ? row.children : undefined;
    if (!cols) return;
  }
}